// Pure utility functions for grouping and keying search results

export function getDocKey(doc) {
  return (
    doc?.documentUUID ||
    doc?.documentUuid ||
    doc?.uuid ||
    doc?.id ||
    doc?.documentId ||
    doc?.key ||
    doc?.fileName ||
    undefined
  );
}

export function buildGroups(rows, raw) {
  // 1) Prefer explicit grouping from raw responses if present
  const groups = [];
  if (raw && Array.isArray(raw.responses)) {
    for (let i = 0; i < raw.responses.length; i++) {
      const resp = raw.responses[i];
      const name =
        resp?.database || resp?.dbName || resp?.db || `Database ${i + 1}`;
      const items = findItemsArray(resp);
      if (Array.isArray(items) && items.length) {
        groups.push({ name, items });
      }
    }
  }
  if (groups.length) return groups;

  // 2) Heuristic: group by a row field
  const getDb = (r) =>
    r?.dbName ||
    r?.database ||
    r?.db ||
    r?.dbname ||
    r?.db_name ||
    "All Databases";
  const map = new Map();
  for (const r of rows || []) {
    const key = getDb(r) || "All Databases";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(r);
  }
  if (map.size === 0) return [{ name: "All Databases", items: rows || [] }];
  return Array.from(map, ([name, items]) => ({ name, items }));
}

export function findItemsArray(node) {
  if (!node) return null;
  const candidates = [
    "results",
    "documents",
    "items",
    "rows",
    "records",
    "hits",
    "data",
  ];
  for (const key of candidates) {
    if (Array.isArray(node?.[key])) return node[key];
  }
  // As a fallback, look for the first array of objects in the object
  for (const v of Object.values(node)) {
    if (
      Array.isArray(v) &&
      v.length &&
      typeof v[0] === "object" &&
      !Array.isArray(v[0])
    )
      return v;
  }
  return null;
}
